export default {
  GARAGE: 1,
  NOTARY: 2,
  EXPERT: 3,
  ESTATE_AGENT: 4,
  LENDER: 5,
  STRUCTURAL_ENGINEER: 7,
};
